export const QUESTION_TYPE = {
    TextQuestion: "escrita" ,
    SingleQuestion: "unica" ,
    MultiQuestion: "multiple"
}

export const TEST_SOUNDS = {
    SUBMIT: 'test-submit',
    SHOW_BUTTON: 'test-showButton',
    DESELECT: 'test-deselect',
    LOAD: 'test-load',
    DELETE: 'test-delete',
    WRITE: 'test-write',
    MOVE: 'test-move'
}